import { gql } from '@apollo/client';

export const getCourse = gql`
  query GetCourse($id: ID) {
    getCourse(id: $id) {
      id
      shortId
      level
      integrity
      examTimeLimitSeconds
      archivedScheduledAt
      archivedAt
      archiveDate
      type
      moodleCourseUrl
      domains {
        id
        name
      }
      name {
        value
        languageCode
      }
      episodes {
        id
        contentType
        status
        name {
          value
          languageCode
        }
        content {
          ... on Game {
            duration
            externalGameId
            type
          }
          ... on Videos {
            id
            duration
            videoFiles {
              key
            }
            file {
              processingStatus
            }
            subtitles {
              file {
                processingStatus
              }
              language {
                code
              }
            }
          }
        }
        attachments {
          id
          name {
            value
            languageCode
          }
          file {
            processingStatus
          }
        }
        ordinal
      }
      prerequisites {
        value
        languageCode
      }
      promoPicture {
        imageFiles {
          key
        }
        file {
          key
          processingStatus
        }
      }
      thumbnail {
        file {
          key
          processingStatus
        }
      }
      description {
        languageCode
        value
      }
      shortDescription {
        value
        languageCode
      }
      spokenLanguage {
        code
      }
      status
      trailer {
        id
        duration
        file {
          processingStatus
        }
        videoFiles {
          key
        }
        subtitles {
          file {
            processingStatus
          }
          language {
            code
          }
        }
      }
      typicalLearner {
        value
        languageCode
      }
      attachments {
        id
        file {
          processingStatus
        }
        name {
          value
          languageCode
        }
      }
      experts {
        id
        lastName
        firstName
        disabled
      }
      learningPoints {
        values
        languageCode
      }
      categories {
        ordinal
        name {
          value
          languageCode
        }
        id
      }
      catalogs {
        id
        name {
          value
          languageCode
        }
      }
      exam {
        ... on Test {
          id
          duration
          questions {
            question {
              value
              languageCode
            }
            answers {
              answer {
                languageCode
                value
              }
              correct
            }
          }
        }
        ... on Game {
          id
          externalGameId
          duration
        }
      }
    }
  }
`;

export const getLessonsProcessingStatus = gql`
  query GetCourse($id: ID) {
    getCourse(id: $id) {
      id
      shortId
      trailer {
        id
        file {
          processingStatus
        }
        subtitles {
          language {
            code
          }
          file {
            processingStatus
          }
        }
      }
      episodes {
        id
        shortId
        attachments {
          id
          file {
            processingStatus
          }
        }
        content {
          ... on Videos {
            id
            file {
              processingStatus
            }
            subtitles {
              language {
                code
              }
              file {
                processingStatus
              }
            }
          }
        }
      }
    }
  }
`;

export const validateGame = gql`
  query validateGame($gameId: ID!) {
    validateGame(gameId: $gameId) {
      name
      type
    }
  }
`;

export const validateCatalogRemoval = gql`
  query validateCatalogRemoval($input: ValidateCatalogRemovalInput!) {
    validateCatalogRemoval(input: $input) {
      allowed
      isGloballyFeatured
      usedInTemplates {
        id
        name {
          languageCode
          value
        }
      }
      organizationErrors {
        organization {
          id
          name
        }
        effectedPlaylists {
          id
          name {
            languageCode
            value
          }
        }
        effectedFeatured
      }
    }
  }
`;
